<script setup lang="ts">
import { ref, watch , computed } from 'vue';
import { useCustomizerStore } from '@/stores/customizer';
import { useRoute } from 'vue-router'
import { useTenant } from '~/composables/useTenant';
import TabsDashboard from '@/components/Tabs/dashboard.vue'
import TabsAlerts from '@/components/Tabs/alerts.vue'
import TabsConfiguration from '@/components/Tabs/configuration.vue'

const route = useRoute()


const customizer = useCustomizerStore();
const priority = ref(customizer.setHorizontalLayout ? 0 : 0);
watch(priority, (newPriority) => {
  priority.value = newPriority;
});

const currentTabComponent = computed(() => {
  const path = route.path.toLowerCase()

  if (path.includes('/dashboard')) return TabsDashboard
  if (path.includes('/alerts')) return TabsAlerts
  if (path.includes('/configuration')) return TabsConfiguration

  return null
})

const tenantRef = await useTenant();
const tenant = tenantRef.value;
const isSBI = computed(() => tenant?.solution === 'SBI');


</script>

<template>
  <v-app-bar elevation="0" :priority="priority" height="50" class="pt-2">
    <v-btn class="hidden-md-and-down" icon aria-label="sidebar button" rounded="sm" variant="text"
      @click.stop="customizer.SET_MINI_SIDEBAR(!customizer.mini_sidebar)"
      style="color:#40403F;width: 50px; height: 50px;">
     <v-icon size="40">
        {{ customizer.mini_sidebar ? 'mdi-menu' : 'mdi-menu' }}
      </v-icon>
    </v-btn>

    <v-btn class="hidden-lg-and-up" icon rounded="sm" variant="text" size="large"
      @click.stop="customizer.SET_SIDEBAR_DRAWER()" style="color:#40403F;width: 50px; height: 50px;">
      <v-icon size="40">
        {{ customizer.mini_sidebar ? 'mdi-menu' : 'mdi-menu' }}
      </v-icon>
    </v-btn>

    <v-spacer />
    <component :is="currentTabComponent" v-if="currentTabComponent && isSBI" />

  </v-app-bar>

</template>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');
@media (max-width: 600px) {
  .v-btn {
    display: block;
  }
}
</style>